import { render, staticRenderFns } from "./NoMore.vue?vue&type=template&id=01c52eb6&"
import script from "./NoMore.vue?vue&type=script&lang=js&"
export * from "./NoMore.vue?vue&type=script&lang=js&"
import style0 from "./NoMore.vue?vue&type=style&index=0&id=01c52eb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.1_@vue+compiler-sfc@3.2.47_css-loader@5.2.5_webpack@4.47.0_webpack-cli@4.10._wyjk5suo23ynklbyyfuevipziy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports